import { Cog, ExclamationTriangle, MoneyCheckAlt, UserCircle } from '@assets/svgs';
import { DrawerListItem } from '@components/index';
import { allRoles } from '@models/user';
import { DrawerList } from '@pages/QuoteDetails/constants/DrawerList.enum';
import { EnablePaymentPortal } from '@utils/api-client';

export const settingsPath = {
  [DrawerList.Notifications]: '/settings/notification-preferences',
  [DrawerList.UserProfile]: '/settings/profile',
  [DrawerList.PaymentMethods]: '/settings/payment-methods',
  [DrawerList.ManageSubjectivities]: '/settings/manage-subjectivities',
};

export const getDrawerListItems = ({
  hasPayerProfile,
  isNotCustomerUser,
  showSubjectivityLibrary = false,
}: {
  hasPayerProfile: boolean;
  isNotCustomerUser: boolean;
  showSubjectivityLibrary: boolean;
}) =>
  [
    {
      icon: <UserCircle />,
      roles: allRoles,
      path: settingsPath[DrawerList.UserProfile],
      name: DrawerList.UserProfile,
    },
    {
      icon: <MoneyCheckAlt />,
      roles: allRoles,
      path: settingsPath[DrawerList.PaymentMethods],
      name: DrawerList.PaymentMethods,
      visible: EnablePaymentPortal && hasPayerProfile,
    },
    {
      icon: <Cog />,
      roles: allRoles,
      path: settingsPath[DrawerList.Notifications],
      name: DrawerList.Notifications,
      visible: hasPayerProfile || isNotCustomerUser,
    },
    {
      icon: <ExclamationTriangle />,
      roles: allRoles,
      path: settingsPath[DrawerList.ManageSubjectivities],
      name: DrawerList.ManageSubjectivities,
      visible: showSubjectivityLibrary,
    },
  ] as DrawerListItem[];
